import "styled-components";
import { DefaultTheme } from "styled-components";
import { darken } from "polished";

// Create a theme declaration as described here:
// https://www.styled-components.com/docs/api#create-a-declarations-file
declare module "styled-components" {
  export interface DefaultTheme {
    font: string;
    monospaceFont: string;

    colors: {
      primary: string;
      danger: string;
      orange: string;
      black: string;
      white: string;
      gray1: string;
      gray2: string;
      green: string;
      mutedText: string;
    };
  }
}

export const frusterTheme: DefaultTheme = {
  font: "Arial,sans-serif",
  monospaceFont: "'Source Code Pro', monospace",

  colors: {
    primary: "#57A35E",
    danger: "#C12020",
    black: "#202020",
    white: "#FFF",
    gray1: "#CCCCCC",
    gray2: "#5A5A5A",
    green: "#57A35E",
    orange: "#EE9936",
    mutedText: darken(0.1, "#ccc")
  }
};
